import { TheWestSection } from '@news-mono/common'
import {
    BreachEvent,
    BreachScreenContext,
    click_origin_breach_screen,
    useFeature,
    useSubscribeWithGoogle,
} from '@news-mono/web-common'
import React, { useContext, useRef } from 'react'
import { IconStar } from '../../../../../../icons/IconStar/IconStar'
import { useAuthActions } from '../../../../../../user-registration/authentication/AuthenticationProvider'
import { useSection, useSectionMetaInfo } from '../../../../../../__helpers'
import { createLinkClickEvent } from '../../../../createLinkClickHandler'
import {
    Ribbon,
    StyledPackageImage,
    StyledSubscriptionCancellationMessage,
    StyledSubscriptionPackage,
    StyledSubscriptionPackageActions,
    StyledSubscriptionPackageButton,
    StyledSubscriptionPackageHeading,
    StyledSubscriptionPackageOriginalPrice,
    StyledSubscriptionPackagePreTitle,
    StyledSubscriptionPackagePrice,
    StyledSubscriptionPackagePriceQualifier,
} from './BlackFridaySubscriptionPackage.styled'
import { ISubscriptionPackage } from '../../../../common'
import { Theme } from '@emotion/react'
import { getCartPayload } from '../../../../../../'

const everyDayDigitalImage = require('../../../SubscriptionPackage/images/updated2022/everyday_digital.png')
const everyDayNewspaperImage = require('../../../SubscriptionPackage/images/updated2022/Weekend-Papers-plus-Everyday-Digita_Mobile.png')

export interface BlackFridaySubscriptionPackageProps {
    subscriptionPackage: ISubscriptionPackage
    breachCreativeName: string
    breachDeal: string
    theme: Theme
    onEvent: (event: BreachEvent) => void
}

export const BlackFridaySubscriptionPackage: React.FC<BlackFridaySubscriptionPackageProps> =
    ({
        subscriptionPackage,
        breachDeal,
        breachCreativeName,
        onEvent,
        theme,
    }) => {
        const { onSubscribeClick } = useAuthActions()
        const subscribeWithGoogleEnabled = useFeature('subscribe-with-google')
        const section = useSection<TheWestSection>()

        const sectionName = section === 'genwest' ? 'default' : section

        // Matches swg-breach-albany-advertiser etc
        const subscribeWithGoogleBreachInterfaceEnabled = useFeature(
            `swg-breach-${sectionName}`,
        )

        const buttonRef = useRef<HTMLButtonElement>(null)

        const showSwG =
            subscribeWithGoogleEnabled &&
            subscribeWithGoogleBreachInterfaceEnabled &&
            subscriptionPackage.googleSKU

        const sectionMeta = useSectionMetaInfo()

        const breachScreenContext = useContext(BreachScreenContext)
        const breachContext = breachScreenContext.context

        useSubscribeWithGoogle(
            buttonRef.current as HTMLButtonElement,
            subscriptionPackage.googleSKU || 'everyday_digital_4weeks',
            sectionMeta,
            breachContext,
        )

        const cartPayload = getCartPayload(subscriptionPackage, theme)
        const packageTheme = subscriptionPackage.packageTheme || 'default'
        const packagePath = subscriptionPackage.packagePath
        const offerCode = subscriptionPackage.offerCode

        return (
            // Note: There is high editorial care factor on these images, please ensure
            // appropriate approvals have happened before replacing or updating
            <StyledSubscriptionPackage packageTheme={packageTheme}>
                {subscriptionPackage.packageType === 'digital' && (
                    <StyledPackageImage
                        src={everyDayDigitalImage}
                        alt=""
                        role="presentation"
                    />
                )}

                {subscriptionPackage.packageType === 'digitalprint' && (
                    <StyledPackageImage
                        src={everyDayNewspaperImage}
                        alt=""
                        role="presentation"
                    />
                )}
                <StyledSubscriptionPackagePreTitle packageTheme={packageTheme}>
                    {subscriptionPackage.pretitle}
                </StyledSubscriptionPackagePreTitle>
                <StyledSubscriptionPackageHeading packageTheme={packageTheme}>
                    {subscriptionPackage.heading}
                </StyledSubscriptionPackageHeading>
                {subscriptionPackage.originalPrice && (
                    <StyledSubscriptionPackageOriginalPrice
                        packageTheme={packageTheme}
                    >
                        {subscriptionPackage.originalPrice}
                    </StyledSubscriptionPackageOriginalPrice>
                )}
                <StyledSubscriptionPackagePrice packageTheme={packageTheme}>
                    {subscriptionPackage.price}
                </StyledSubscriptionPackagePrice>
                {subscriptionPackage.priceQualifier && (
                    <StyledSubscriptionPackagePriceQualifier
                        packageTheme={packageTheme}
                    >
                        {subscriptionPackage.priceQualifier}
                    </StyledSubscriptionPackagePriceQualifier>
                )}
                {subscriptionPackage.ribbonTitle && (
                    <Ribbon packageTheme={packageTheme}>
                        <span>
                            <IconStar />
                            {subscriptionPackage.ribbonTitle}
                        </span>
                    </Ribbon>
                )}
                <StyledSubscriptionPackageActions>
                    <StyledSubscriptionPackageButton
                        packageTheme={packageTheme}
                        buttonWidth="wide"
                        onClick={() => {
                            createLinkClickEvent(
                                breachCreativeName,
                                breachDeal,
                                onEvent,
                                undefined,
                                1,
                                cartPayload,
                            )()
                            onSubscribeClick({
                                packagePath,
                                offerCode,
                                callToAction: click_origin_breach_screen,
                            })
                        }}
                    >
                        Subscribe Now
                    </StyledSubscriptionPackageButton>
                    <StyledSubscriptionCancellationMessage
                        packageTheme={packageTheme}
                    >
                        {subscriptionPackage.cancellationMessage}
                    </StyledSubscriptionCancellationMessage>
                    {/* {packageType === 'digital' && showSwG && (
                        <StyledSubscribeWithGoogleButton ref={buttonRef} />
                    )} */}
                </StyledSubscriptionPackageActions>
            </StyledSubscriptionPackage>
        )
    }

BlackFridaySubscriptionPackage.displayName = 'BlackFridaySubscriptionPackage'

export default BlackFridaySubscriptionPackage
